import React from "react";

const NoSchedulesAfter = ({ endDate, beach }) => (
  <div className="container p-0">
    <div className="schedule-well mt-2 mb-2 text-center p-4">
      <h4>
        <i className="far fa-calendar-exclamation" /> There are no new schedules available for {beach} after the current schedule ends on {endDate}.
      </h4>
    </div>
  </div>
);

export default NoSchedulesAfter;
